export default __webpack_public_path__ + "static/media/cardSend.5ddb1001.svg";